let globals;
if (process.env.APP_ENV === "production") {
  globals = require("./globals.production").default;
} else if (process.env.APP_ENV === "staging") {
  globals = require("./globals.staging").default;
} else if (process.env.APP_ENV === "alpha") {
  globals = require("./globals.alpha").default;
} else if (process.env.APP_ENV === "beta") {
  globals = require("./globals.beta").default;
} else {
  globals = require("./globals.development").default;
}

const {
  RAILS_PORT,
  CWA_PUBLIC_URL,
  RAILS_PUBLIC_URL,
  RAILS_PACKS_URL,
  RAILS_API_URL,
  RAVEN_PUBLIC_DSN,
  GOOGLE_PUBLIC_API_KEY,
  APP_ENV = process.env.APP_ENV,
  APP_RELEASE = process.env.APP_RELEASE,
  STRIPE_KEY,
  LOCAL_STORAGE_AUTH_TOKEN_PATH
} = globals;

export {
  RAILS_PORT,
  CWA_PUBLIC_URL,
  RAILS_PUBLIC_URL,
  RAILS_PACKS_URL,
  RAILS_API_URL,
  RAVEN_PUBLIC_DSN,
  GOOGLE_PUBLIC_API_KEY,
  APP_ENV,
  APP_RELEASE,
  STRIPE_KEY,
  LOCAL_STORAGE_AUTH_TOKEN_PATH
};



// WEBPACK FOOTER //
// ./src/config/globals.js